import { IStore } from '../types/IStore';

export const getChannelUrl = (state: IStore) => state.chat.channelUrl;
export const getAssignedChannels = (state: IStore) => state.chat.assignedChannels;
export const userUnreadCountSelector = (state: IStore) => state.chat.userUnreadCount;
export const getSelectedClient = (state:IStore) => state.chat.selectedClient;
export const getAdminChannelUrl = (state: IStore) => state.chat.adminChannelUrl;
export const getChannelProperties = (state: IStore) => state.chat.channelProperties;
export const channelsMetadata = (state: IStore) => state.chat.channelMetaData;
export const chatActiveTab = (state: IStore) => state.chat.activeTab;
export const getPharmacyChannelUrl = (state: IStore) => state.chat.pharmacyChannelUrl;
export const getProfessionalChannelUrl = (state: IStore) => state.chat.professionalChannelUrl;
export const getChatTabCount = (state: IStore) => state.chat.unreadTabCount;
export const getChatSearchText = (state: IStore) => state.chat.searchedText;
export const getEnteredChannelUrl = (state: IStore) => state.chat.enteredChannelUrl;
export const getClientTabCount = (state: IStore) => state.chat.clientUnreadTabCount;